import { AuditEntityType } from '@clh/api-client';
import { getTextFromQuillDeltas, toDollarAmount } from '@clh/util';

export function friendlyValue(
    field: string,
    value: any,
    entityType?: AuditEntityType
) {
    if (!value) {
        return value;
    }
    if (field === 'payRate' || field === 'totalRate') {
        return toDollarAmount(value);
    }
    if (field === 'amount' && entityType === AuditEntityType.Bonus) {
        return toDollarAmount(value);
    }
    if (field === 'description') {
        try {
            return getTextFromQuillDeltas(value);
        } catch (_) {
            // Oh well
        }
    }

    return value;
}
